export const ADD_BLOCK = 'addBlock'
export const ADD_SECTION = 'addSection'
export const ADD_REPEATER_CARD = 'addRepeaterCard'
export const ADD_REPEATER_TEXT_CARD = 'addRepeaterTextCard'
export const ADD_ACCORDION_CARD = 'addAccordionCard'
export const DELETE_BLOCK = 'deleteBlock'
export const SET_CARD_IMG = 'setCardImg'
export const CHANGE_ORDER_BLOCK = 'changeOrderBlock'
export const ADD_SLIDER_CARD = 'addSliderCard'
export const DELETE_CARD = 'deleteCard'
export const CHANGE_ORDER_CARD = 'changeOrderCard'
export const IMPORT_MEMBERS = 'importMembers'
export const EXPORT_MEMBERS = 'exportMembers'

export const ADD_BLOCK_AUTHOR = 'addBlockAuthor'
export const CHANGE_ORDER_BLOCK_AUTHOR = 'changeOrderBlockAuthor'
export const SET_AUTHOR_IMG = 'setAuthorImg'
export const DELETE_BLOCK_AUTHOR = 'deleteBlockAuthor'
export const TOGGLE_BLOCK = 'toggleBlock'
export const TOGGLE_BLOCK_AUTHOR = 'toggleBlockAuthor'
export const TOGGLE_BLOCK_CARD = 'toggleBlockCard'

export const CERTIFICATE_PARAM_BASIC = [{
	label: 'Имя',
	value: 'first_name',
	checked: true
}, {
	label: 'Фамилия',
	value: 'last_name',
	checked: true
}, {
	label: 'Пол',
	value: 'gender',
	checked: true
}, {
	label: 'Название на сертификате',
	value: 'certName',
	checked: true
}, {
	label: 'Список подписантов',
	value: 'mentors',
	checked: true
}, {
	label: 'Список организаторов',
	value: 'organizers',
	checked: true
}, {
	label: 'Список партнеров',
	value: 'partners',
	checked: true
}]

export default {
	ADD_BLOCK,
	ADD_SECTION,
	CHANGE_ORDER_BLOCK,
	DELETE_BLOCK,
	ADD_REPEATER_CARD,
	ADD_SLIDER_CARD,
	SET_CARD_IMG,
	CHANGE_ORDER_CARD,
	DELETE_CARD,
	IMPORT_MEMBERS,
	EXPORT_MEMBERS,
	ADD_BLOCK_AUTHOR,
	DELETE_BLOCK_AUTHOR,
	CHANGE_ORDER_BLOCK_AUTHOR,
	SET_AUTHOR_IMG,
	ADD_REPEATER_TEXT_CARD,
	ADD_ACCORDION_CARD,
	TOGGLE_BLOCK,
	TOGGLE_BLOCK_AUTHOR,
	TOGGLE_BLOCK_CARD,
	CERTIFICATE_PARAM_BASIC
}



// WEBPACK FOOTER //
// ./src/assets/js/Event/constants.js